import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-mobile-footer-navigation',
  templateUrl: './mobile-footer-navigation.component.html',
  styleUrls: ['./mobile-footer-navigation.component.scss'],
})
export class MobileFooterNavigationComponent {
  @Input() questions: {
    progress: boolean;
    attended: boolean;
    error: boolean;
  }[] = [];
  @Input() currentQuestion: number;
  @Input() totalQuestions: number;
  @Input() previousEnabled: boolean;
  @Input() nextEnabled: boolean;
  @Input() showBannerOnMobile: boolean;
  @Output() previous = new EventEmitter();
  @Output() next = new EventEmitter();
  showHeader = false;

  ngOnInit() {
    this.check();
  }

  goPrevious() {
    if (this.previousEnabled) {
      this.previous.emit();
    }
  }

  goNext() {
    if (this.nextEnabled) {
      this.next.emit();
    }
  }

  styleProgressBtns(direction: string) {
    if (direction === 'next' && this.nextEnabled) {
      return { opacity: 1 };
    } else if (direction === 'prev' && this.previousEnabled) {
      return { opacity: 1 };
    } else {
      return { opacity: 0.25 };
    }
  }

  check() {
    const checkExists = setInterval(() => {
      if (!isNaN(this.currentQuestion)) {
        this.showHeader = true;
        clearInterval(checkExists);
      }
    }, 200);
  }
}
